module.exports = __webpack_public_path__ + "static/img/aRZ_pic05.43b6049.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aRZ_pic05.jpg
// module id = 9kGP
// module chunks = 5